const source = 'pdrsDataTable'

function riattivazioni () {
  const keys = Object.keys(this.filtered.items).filter((s) => s == source)
  if(keys.length > 0){
    const ids = this.filtered.items[source]

    this.$eventBus.emit('show-dialog-page', {
      page: 'pdrs-sospensioni-riattivazioni',
      title: 'Riattivazioni',
      data: {ids, type:'riattivazioni'},
      maximize: false,
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': riattivazioni,
}
